import { connect } from 'react-redux';
import Button from '../audi-ui-components/Button';
import { DEFAULT_THEME } from '../constants';

const mapStateToProps = state => {
    return {
        currentDealer: state.dealers && state.dealers.current,
        return_url: state.ui.return_url
    };
}

const ReturnToButton = ({ query, theme = DEFAULT_THEME, currentDealer, return_url }) => {

    const homepageLink = currentDealer ? currentDealer.Website : 'https://www.audi.com.au/en/';
    const embedded = query.embedded || (typeof window !== "undefined" && window.location !== window.parent.location);

    if (return_url) {
        return (
            <Button href={return_url} target={embedded ? "_parent" : "_self"} variant="primary" theme={theme === "dark" ? "light" : null}>Back</Button>
        );
    } else if (homepageLink) {
        return (
            <Button href={homepageLink} target={embedded ? "_parent" : "_self"} variant="primary" theme={theme === "dark" ? "light" : null}>Back to home</Button>
        );
    }
    return null;
}

export default connect(mapStateToProps)(ReturnToButton);
